<h1 class="titles">
  <span>4/4</span> ÐÐ¾Ð¼Ð°, Ð´Ð»Ñ ÑÐ°ÑÐ¾Ð² ÐºÐ¾ÑÐ¾ÑÑÑ Ð°ÐºÑÑÐ°Ð»ÑÐ½Ð¾ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ
</h1>

<arm-spinner *ngIf="loading" class="spinner"></arm-spinner>

<arm-serviced-houses *ngIf="!loading"></arm-serviced-houses>

<lib-button (click)="nextStep()">ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ</lib-button>
